import { axiosInstance } from '../config';
import { getUserSession, getHeaders } from '../authentication';

export const getAllCompanyNames = () => {
  const config = getHeaders(getUserSession());
  return axiosInstance.get('companyNames/list',config);
};

export const getCompanyNamesByKey = (key) => {
  const config = getHeaders(getUserSession());
  return axiosInstance.get('companyNames/byKey/' + key,config);
};

export const getCompanyNameById = (id) => {
  const config = getHeaders(getUserSession());
  return axiosInstance.get('companyNames/byId/' + id,config);
};

export const getCompanyNameByName = (name) => {
  const config = getHeaders(getUserSession());
  return axiosInstance.get('companyNames/byName/' + name,config);
};

export const getCompanyNameByIdClient = (idClient) => {
  const config = getHeaders(getUserSession());
  return axiosInstance.get('companyNames/byIdClient/' + idClient,config);
};

export const companyNameCreate = (client) => {
  const config = getHeaders(getUserSession());
  return axiosInstance.post('companyName',client,config);
};

export const companyNameUpdate = (client) => {
  const config = getHeaders(getUserSession());
  return axiosInstance.put('companyNames/update',client,config);
};
